import { Box, Flex, Text } from '@radix-ui/themes'
import cn from 'classnames'
import { STAGE_OPTIONS, stageBarBgClass, stageLabel, type Stage } from '../constants'

interface StageProgressBarProps {
  byStage: Record<Stage, number>
  total: number
  showLegend?: boolean
}

export const StageProgressBar = ({ byStage, total, showLegend = true }: StageProgressBarProps) => {
  if (total === 0) return null

  const segments = STAGE_OPTIONS.map((stage) => ({
    stage,
    count: byStage[stage],
    percent: Math.round((byStage[stage] / total) * 100)
  })).filter((segment) => segment.count > 0)

  return (
    <Flex direction="column" gap="2">
      <Flex className="h-2 w-full rounded-full overflow-hidden bg-[var(--gray-a3)]">
        {segments.map((segment) => (
          <Box
            key={segment.stage}
            className={cn('h-full', stageBarBgClass[segment.stage])}
            style={{ width: `${(segment.count / total) * 100}%` }}
            title={`${stageLabel[segment.stage]}: ${segment.count}`}
          />
        ))}
      </Flex>

      {showLegend && (
        <Flex gap="4" wrap="wrap">
          {segments.map((segment) => (
            <Flex key={segment.stage} align="center" gap="2">
              <Box className={cn('h-2.5 w-2.5 rounded-full shrink-0', stageBarBgClass[segment.stage])} />
              <Text size="1">
                {stageLabel[segment.stage]}{' '}
                <Text color="gray">
                  {segment.count} ({segment.percent}%)
                </Text>
              </Text>
            </Flex>
          ))}
        </Flex>
      )}
    </Flex>
  )
}
